import { useMemo } from "react";

import { CustomerDoc } from "@megaron/docs-contracts";
import { useClientManager } from "@megaron/react-clients";
import { TicketDetailDto } from "@megaron/support-contracts";
import { Uuid } from "@megaron/uuid";

export function useResolvedCrmCustomerId(ticket: TicketDetailDto): Uuid | undefined {
  const primaryUuid = ticket.customerUuids[0];

  const docsRetrieveQuery = useClientManager("docs")
    .retrieveDocs()
    .useQuery(
      { docIds: primaryUuid ? [`customer:${primaryUuid}`] : [] },
      { enabled: !!primaryUuid },
    );

  const searchQuery = useClientManager("docs")
    .searchCustomers()
    .useQuery(
      { searchText: ticket.reporterEmail.trim(), limit: 10 },
      { enabled: !primaryUuid && !!ticket.reporterEmail.trim() },
    );

  return useMemo(() => {
    if (primaryUuid) return primaryUuid;
    const lower = ticket.reporterEmail.trim().toLowerCase();
    const matched = (searchQuery.data?.items ?? []).find(
      (c: CustomerDoc) => c.email?.trim().toLowerCase() === lower,
    );
    return matched?.uuid;
  }, [primaryUuid, ticket.reporterEmail, docsRetrieveQuery.data, searchQuery.data]);
}
